import styled from "styled-components";
import MenuPopup from "@streeteasy/design-system/legacy/MenuPopup";

export const NavListItem = styled.li`
  display: inline-block;
  line-height: 1.1;
  list-style: none;
  position: relative;
`;

export const CaretIcon = styled.i.attrs({
  className: "fa fa-angle-down"
})``;

export const StyledMenuPopup = styled(MenuPopup)`
  position: absolute;
  right: -10px;
  top: 100%;
  width: 220px;
  z-index: 10;
`;
